// -----------------------------------------------------------------------------
// Script for activities panel
// -----------------------------------------------------------------------------


function activitiesPanel(event) {
  if ($('body').hasClass('tax-activity')) {
      $('html, body').animate({
        scrollTop: $("#results").offset().top
      }, 2000);
    }
}